const cookieUtils = require("cookie-utils"); 

try{
	cookieUtils.initializeCookieManager(getCookieDomain(), 'web');
    cookieUtils.cookieManager.initializeMasterCookie();
}catch(e){
	console.error(e);
}

class CookieUtils {
    static getCookie(name) {
        return decodeURIComponent(
        ("; " + document.cookie)
            .split("; " + name + "=")
            .pop()
            .split(";")
            .shift()
        );
    }
    static getCartCount(){
        //TODO: to look into why it is necessary to call that again.
        cookieUtils.cookieManager.initializeMasterCookie();
    	return cookieUtils.getTHDNumberItemsInCart()
    }
}
export default CookieUtils;

function getCookieDomain(){
    var currentHost = window.location.hostname;
    return currentHost.indexOf('qa') > 0 ? "." + currentHost : ".homedepot.com";
}
